// Love (Oct 2026, the discovery plan's heart, after Apple Music's): a heart on
// every tile of the home page's shelves. It is a toggle (pressed again, the
// mark comes off). What it records is state/tuneTaste.ts; what it changes is
// Top picks and the More like shelves (src/music/recommend.ts) and the Loved
// shelf. Suggest less and the tune screen's buttons were retired (user, Oct
// 2026: "they are not very useful as only shared on home page… I don't even
// like the suggest less option").

import { Heart } from 'lucide-react';
import { recordFeature } from '@/analytics/usage';
import { useStore } from '@/state/store';
import { tasteMarkOf, tasteOf, type TasteTune } from '@/state/tuneTaste';
import { showHomeNotice } from './homeNotice';

/** A change that takes the tile away, so the change offers an Undo: taking a
 * tune off the Loved shelf. */
export type TasteHides = 'unlove';

/** The heart on a home tile, in the tile's row of actions. A mark that read
 * Suggest less shows as unloved, and the heart replaces it. */
export function TasteButtons({ tune, hides }: { tune: TasteTune; hides?: TasteHides }) {
  const loved = useStore((s) => tasteOf(s.tuneTaste, tune) === 'love');
  const toggle = () => {
    const store = useStore.getState();
    const previous = tasteMarkOf(store.tuneTaste, tune) ?? null;
    store.setTuneTaste(tune, loved ? null : 'love');
    if (!loved) {
      recordFeature('love');
    } else if (hides === 'unlove') {
      showHomeNotice(`${tune.title} removed from Loved`, () =>
        useStore.getState().restoreTuneTaste(tune, previous),
      );
    }
  };
  return (
    <button
      type="button"
      className="tile-action"
      aria-pressed={loved}
      aria-label={`Love ${tune.title}`}
      title="Love"
      data-testid="taste-love"
      onClick={toggle}
    >
      <Heart size={16} aria-hidden="true" fill={loved ? 'currentColor' : 'none'} />
    </button>
  );
}
